import {
    utils,
} from 'pixi.js';
import { BATTLE_BOARD_TO_POINT_RELATION, BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION, BATTLE_POINT_TO_SHURIKEN_EDGE } from '../../BattleConst';

import { CardData } from '../../components/CardData';
import { userDataManager } from '../../utils/UserDataManager';

export const BATTLE_STATE = {
    DEFAULT : 1,
    LOADING : 2,
    START_BATTLE : 3,
    IN_BATTLE : 4,
    BATTLE_SHURIKEN_RESULT : 5,
    BATTLE_RESULT : 6,
    END_BATTLE : 7,
};

export const TURN_STATE = {
    HOST_START : 1,
    HOST_END : 2,
    GUEST_START : 4,
    GUEST_END : 5,
    BATTLE_EFFECT : 6,
};

export const EVENT = {
    CHANGE_BATTLE_STATE : 'CHANGE_BATTLE_STATE',
    CHANGE_TURN_STATE : 'CHANGE_TURN_STATE',
    PUT_CARD : 'PUT_CARD',
};

export class BattleManager {
    constructor(hostPlayerId, guestPlayerId, cpuData){
        this.hostHands = new Map();
        this.guestHands = new Map();
        this.event = new utils.EventEmitter();
        this.ChangeBattleState(BATTLE_STATE.DEFAULT);
        this.hostIsReady = false;
        this.guestIsReady = false;
        this.putCards = new Map();
        this.hostPlayerId = hostPlayerId;
        this.guestPlayerId = guestPlayerId;
        this.cpuData = cpuData;

        // 勝った場所を保持する
        this.hostWinPoints = [];
        this.guestWinPoints = [];
        // 役が成立した場所を保持する
        this.hostYaku = {
            'iro2':[],
            'iro3':[],
            'kazu2':[],
            'kazu3':[],
            'mai3': [],
            'ten': [],
        };

        this.guestYaku = {
            'iro2':[],
            'iro3':[],
            'kazu2':[],
            'kazu3':[],
            'mai3': [],
            'ten': [],
        };
    }

    Update(){
        switch(this.battleState){
        case BATTLE_STATE.DEFAULT:
            this.ChangeBattleState(BATTLE_STATE.LOADING);
            this.SetHands();
            break;
        case BATTLE_STATE.LOADING:
            break;
        case BATTLE_STATE.START_BATTLE:
            break;
        case BATTLE_STATE.IN_BATTLE:
            break;
        case BATTLE_STATE.END_BATTLE:
            break;
        }
    }


    ChangeBattleState(state){
        this.battleState = state;
        this.event.emit(EVENT.CHANGE_BATTLE_STATE, state);
    }

    ChangeTurnState(state){
        this.turnState = state;
        this.event.emit(EVENT.CHANGE_TURN_STATE, state);
    }

    async SetHands(){
        // WEBサーバーから自分と敵のデッキ情報を取得する
        await new Promise((resolve) => setTimeout(resolve, 1000)); // 通信挟む想定なので擬似的に待機させる

        for(let i = 0; i < 5; i++){
            const card = userDataManager.getDeckCardData(1, i + 1);
            await card.Init();

            this.hostHands.set(
                i,
                card,
            );
        }

        for(let i = 0; i < 5; i++){
            const cardData = this.cpuData.cards[i];
            const card = CardData.CreateReplaceCardData(cardData, this.guestPlayerId);  
            await card.Init();

            this.guestHands.set(
                i,
                card,
            );
        }
        this.ChangeBattleState(BATTLE_STATE.START_BATTLE);
    }

    Ready(isHost){
        if(isHost)
        {
            this.hostIsReady = true;
        }
        else
        {
            this.guestIsReady = true;
        }
        if(this.hostIsReady && this.guestIsReady)
        {
            this.ChangeBattleState(BATTLE_STATE.IN_BATTLE);
            if(0.5 <= Math.random())
            {
                this.ChangeTurnState(TURN_STATE.HOST_START);
            }
            else
            {
                this.ChangeTurnState(TURN_STATE.GUEST_START);
            }
        }
    }

    async PutCard(playerId, boardIndex, cardIndex, rotateCount){
        // カード置けるstateでなければ受け入れない
        if(this.turnState != TURN_STATE.HOST_START && this.turnState != TURN_STATE.GUEST_START) return;
        if(this.putCards.has(boardIndex))
        {
            console.error('配置済みエラー');
            return;
        }
        const isHostAction = playerId == this.hostPlayerId;

        // 
        var card = null;
        if(isHostAction)
        {
            if(this.turnState != TURN_STATE.HOST_START) return;
            this.ChangeTurnState(TURN_STATE.HOST_END);
            card = this.hostHands.get(cardIndex);
            this.hostHands.delete(cardIndex);
        }
        else
        {
            if(this.turnState != TURN_STATE.GUEST_START) return;
            this.ChangeTurnState(TURN_STATE.GUEST_END);
            card = this.guestHands.get(cardIndex);
            this.guestHands.delete(cardIndex);
        }
        card.setRotateCount(rotateCount);

        this.putCards.set(boardIndex, card);

        this.event.emit(EVENT.PUT_CARD, playerId, boardIndex, cardIndex, rotateCount);

        // TODO: バトル判定
        this.checkBattle(boardIndex);

        // ゲーム終了判定
        if(8 <= this.putCards.size)
        {
            this.checkUseShurikenPlayer();
            this.checkYakuFinal();
            if(this.useShurikenPlayerId != 0)
            {
                this.ChangeBattleState(BATTLE_STATE.BATTLE_SHURIKEN_RESULT);
                await new Promise((resolve) => setTimeout(resolve, 3000));
            }
            this.ChangeBattleState(BATTLE_STATE.BATTLE_RESULT);
            await new Promise((resolve) => setTimeout(resolve, 3000));            
            this.ChangeBattleState(BATTLE_STATE.END_BATTLE);
        }
        else
        {
            // ターン切り替え
            if(isHostAction)
            {
                this.ChangeTurnState(TURN_STATE.GUEST_START);
            }
            else
            {
                this.ChangeTurnState(TURN_STATE.HOST_START);
            }
        }
    }

    checkBattle(boardIndex)
    {
        const targetPoinstIndexes = BATTLE_BOARD_TO_POINT_RELATION[boardIndex];

        const pointMap = {};
        targetPoinstIndexes.forEach(targetPoinstIndex => {
            const targetBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[targetPoinstIndex]).map(str => parseInt(str));
            pointMap[targetPoinstIndex] = {
                isStartBattle: true,
                hostPointSum: 0,
                guestPointSum: 0,
            };
            targetBoardIndexes.forEach(targetBoardIndex => {
                const card = this.putCards.get(targetBoardIndex);
                if(card)
                {
                    const vertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[targetPoinstIndex][targetBoardIndex];
                    if(card.playerId == this.hostPlayerId)
                    {
                        pointMap[targetPoinstIndex].hostPointSum += card.getVertexValue(vertex);
                    }
                    else
                    {
                        pointMap[targetPoinstIndex].guestPointSum += card.getVertexValue(vertex);
                    }
                }
                else
                {
                    pointMap[targetPoinstIndex].isStartBattle = false;
                }
            });
            if(pointMap[targetPoinstIndex].isStartBattle)
            {
                if(pointMap[targetPoinstIndex].hostPointSum != pointMap[targetPoinstIndex].guestPointSum)
                {
                    if(pointMap[targetPoinstIndex].hostPointSum < pointMap[targetPoinstIndex].guestPointSum)
                    {
                        this.guestWinPoints.push(targetPoinstIndex);
                    }
                    else
                    {
                        this.hostWinPoints.push(targetPoinstIndex);
                    }
                }
            }
        });
        this.checkYakuFinal();
        this.ChangeTurnState(TURN_STATE.BATTLE_EFFECT);
    }

    checkUseShurikenPlayer()
    {
        // TODO: これは雑な仮実装
        const shurikenBoardIndexes = [1, 3, 4, 6];
        let hostPoint = 0;
        let guestPoint = 0;
        this.useShurikenPlayerId = 0;
        shurikenBoardIndexes.forEach(boardIndex => {
            const card = this.putCards.get(boardIndex);
            if(card.playerId == this.hostPlayerId)
            {
                hostPoint += card.getVertexValue(0);
            }
            else
            {
                guestPoint += card.getVertexValue(0);
            }
        });
        if(hostPoint == guestPoint) return;
        if(hostPoint > guestPoint)
        {
            this.useShurikenPlayerId = this.hostPlayerId;
        }
        else
        {
            this.useShurikenPlayerId = this.guestPlayerId;
        }
    }

    checkYakuFinal()
    {
        this.hostYaku = {
            'iro2':[],
            'iro3':[],
            'kazu2':[],
            'kazu3':[],
            'mai3': [],
            'ten': [],
        };

        this.guestYaku = {
            'iro2':[],
            'iro3':[],
            'kazu2':[],
            'kazu3':[],
            'mai3': [],
            'ten': [],
        };

        const pointIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION);
        pointIndexes.forEach(pointIndex => {
            const targetBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex]).map(str => parseInt(str));
            const hostValue = [];
            const hostColor = [];
            const guestValue = [];
            const guestColor = [];
            // カードが出揃っているか判定
            if(!targetBoardIndexes.every(targetBoardIndex => this.putCards.get(targetBoardIndex) != null)){
                return;
            }

            targetBoardIndexes.forEach(targetBoardIndex => {
                const card = this.putCards.get(targetBoardIndex);
                const vertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex][targetBoardIndex];
                if(card.playerId == this.hostPlayerId)
                {
                    hostValue.push(card.getVertexValue(vertex));
                    hostColor.push(card.getVertexElementId(vertex));
                }
                else
                {
                    guestValue.push(card.getVertexValue(vertex));
                    guestColor.push(card.getVertexElementId(vertex));
                }
            });
            // ホスト役判定
            if(2 <= hostValue.length)
            {
                if(3 <= hostValue.length)
                {
                    // サンマイ同色は確定
                    this.hostYaku.mai3.push(pointIndex);
                    // 値が全て同じならサンコ同数
                    if(hostValue.every(v => v === hostValue[0])){
                        this.hostYaku.kazu3.push(pointIndex);
                    }
                    else if(!hostValue.every((v, i, self) => self.indexOf(v) === i))
                    {
                        // 1つ以上は重複があるのでニコ同数
                        this.hostYaku.kazu2.push(pointIndex);
                    }
                    // 値が全て同じならサンコ同色
                    if(hostColor.every(v => v === hostColor[0])){
                        this.hostYaku.iro3.push(pointIndex);
                    }
                    else if(!hostColor.every((v, i, self) => self.indexOf(v) === i))
                    {
                        // 1つ以上は重複があるのでニコ同色
                        this.hostYaku.iro2.push(pointIndex);
                    }
                }
                else
                {
                    // 値が全て同じならニコ同数
                    if(hostValue.every(v => v === hostValue[0])){
                        this.hostYaku.kazu2.push(pointIndex);
                    }
                    // 値が全て同じならニコ同色
                    if(hostColor.every(v => v === hostColor[0])){
                        this.hostYaku.iro2.push(pointIndex);
                    }
                }
            }

            // ゲスト役判定
            if(2 <= guestValue.length)
            {
                if(3 <= guestValue.length)
                {
                    // サンマイ同色は確定
                    this.guestYaku.mai3.push(pointIndex);
                    // 値が全て同じならサンコ同数
                    if(guestValue.every(v => v === guestValue[0])){
                        this.guestYaku.kazu3.push(pointIndex);
                    }
                    else if(!guestValue.every((v, i, self) => self.indexOf(v) === i))
                    {
                        // 1つ以上は重複があるのでニコ同数
                        this.guestYaku.kazu2.push(pointIndex);
                    }
                    // 値が全て同じならサンコ同色
                    if(guestColor.every(v => v === guestColor[0])){
                        this.guestYaku.iro3.push(pointIndex);
                    }
                    else if(!guestColor.every((v, i, self) => self.indexOf(v) === i))
                    {
                        // 1つ以上は重複があるのでニコ同色
                        this.guestYaku.iro2.push(pointIndex);
                    }
                }
                else
                {
                    // 値が全て同じならニコ同数
                    if(guestValue.every(v => v === guestValue[0])){
                        this.guestYaku.kazu2.push(pointIndex);
                    }
                    // 値が全て同じならニコ同色
                    if(guestColor.every(v => v === guestColor[0])){
                        this.guestYaku.iro2.push(pointIndex);
                    }
                }
            }
        });
    }

    checkYaku(checkBoardIndex, checkPointIndex, checkCardData, checkVertex)
    {
        const targetBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[checkPointIndex]).map(str => parseInt(str));
        const playerValue = [];
        const playerColor = [];
        targetBoardIndexes.forEach(targetBoardIndex => {
            if(checkBoardIndex == targetBoardIndex)
            {
                playerValue.push(checkCardData.getVertexValue(checkVertex));
                playerColor.push(checkCardData.getVertexElementId(checkVertex));
                return;
            }
            if(!this.putCards.has(targetBoardIndex)) return;
            const card = this.putCards.get(targetBoardIndex);
            const vertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[checkPointIndex][targetBoardIndex];
            if(card.playerId == checkCardData.playerId)
            {
                playerValue.push(card.getVertexValue(vertex));
                playerColor.push(card.getVertexElementId(vertex));
            }
        });

        return this.calcYaku(playerValue, playerColor);
    }

    calcYaku(values, colors)
    {
        const yaku = {
            'iro2':0,
            'iro3':0,
            'kazu2':0,
            'kazu3':0,
            'mai3': 0,
            'ten': 0,
        };

        if(3 <= values.length)
        {
            // サンマイ同色は確定
            yaku.mai3++;
            yaku.ten+= 2;
            // 値が全て同じならサンコ同数
            if(values.every(v => v === values[0])){
                yaku.kazu3++;
                yaku.ten+= 2;
            }
            else if(!values.every((v, i, self) => self.indexOf(v) === i))
            {
                // 1つ以上は重複があるのでニコ同数
                yaku.kazu2++;
                yaku.ten+= 1;
            }
            // 値が全て同じならサンコ同色
            if(colors.every(v => v === colors[0])){
                yaku.iro3++;
                yaku.ten+= 2;
            }
            else if(!colors.every((v, i, self) => self.indexOf(v) === i))
            {
                // 1つ以上は重複があるのでニコ同色
                yaku.iro2++;
                yaku.ten+= 1;
            }
        }
        if(2 <= values.length)
        {
            // 値が全て同じならニコ同数
            if(values.every(v => v === values[0])){
                yaku.kazu2++;
                yaku.ten+= 1;
            }
            // 値が全て同じならニコ同色
            if(colors.every(v => v === colors[0])){
                yaku.iro2++;
                yaku.ten+= 1;
            }
        }
        return yaku;
    }

    getResult(playerId, shuriken = null)
    {
        const yakuTenMap = {
            'iro2':1,
            'iro3':2,
            'kazu2':1,
            'kazu3':2,
            'mai3': 2,
        };
        const yakuCount = {
            'iro2':0,
            'iro3':0,
            'kazu2':0,
            'kazu3':0,
            'mai3': 0,
        };
        let yakuTen = 0;
        const yakuMap = this.hostPlayerId == playerId ? this.hostYaku : this.guestYaku;
        let isPlayerShuriken = false; // 加点は自分にだけ、減点は相手にだけ、を実現するための手裏剣保有者判定フラグ

        const ignorePointIndexes = [];
        const triplePointIndexes = [];
        if(shuriken != null)
        {
            isPlayerShuriken = playerId == shuriken.playerId;
            const targetBattlePointIndexes = Object.keys(BATTLE_POINT_TO_SHURIKEN_EDGE).map(str => parseInt(str));
            targetBattlePointIndexes.forEach(pointIndex => {
                if(0 < shuriken.getEdgeEffect(BATTLE_POINT_TO_SHURIKEN_EDGE[pointIndex]))
                {
                    triplePointIndexes.push(pointIndex);
                }
                else if (shuriken.getEdgeEffect(BATTLE_POINT_TO_SHURIKEN_EDGE[pointIndex]) < 0)
                {
                    ignorePointIndexes.push(pointIndex);
                }
            });
        }

        Object.keys(yakuCount).forEach(yakuName => {
            const pointIndexes = yakuMap[yakuName].map(str => parseInt(str));
            pointIndexes.forEach(pointIndex => {
                if(!isPlayerShuriken && -1 != ignorePointIndexes.indexOf(pointIndex))
                {
                    // 無視
                }
                else if(isPlayerShuriken && -1 != triplePointIndexes.indexOf(pointIndex))
                {
                    // 3倍加点
                    yakuCount[yakuName] += 3;
                    yakuTen += (3 * yakuTenMap[yakuName]);
                }
                else
                {
                    // 通常加点
                    yakuCount[yakuName] += 1;
                    yakuTen += 1 * yakuTenMap[yakuName];
                }
            });
        });

        const winPoints = this.hostPlayerId == playerId ? this.hostWinPoints : this.guestWinPoints;
        let katiTen = 0;
        winPoints.forEach(pointIndex => {
            if(!isPlayerShuriken && -1 != ignorePointIndexes.indexOf(pointIndex))
            {
                // 無視
            }
            else if(isPlayerShuriken && -1 != triplePointIndexes.indexOf(pointIndex))
            {
                // 3倍加点
                katiTen += 3;
            }
            else
            {
                // 通常加点
                katiTen += 1;
            }
        });

        yakuCount['yakuTen'] = yakuTen;
        yakuCount['katiTen'] = katiTen;
        return yakuCount;
    }
}
